import { some } from 'lodash'

import { PATENT_REGEX_PATTERNS } from '../../consts'
import { isInJurisdiction } from '../is-in-jurisdiction'

export function validatePatentFormat(
  value: string,
  allowOutOfJurisdiction = false
): boolean {
  if (!allowOutOfJurisdiction) {
    const isValid = isInJurisdiction(value.slice(0, 2))
    if (!isValid) {
      return false
    }
  }
  value = value.replaceAll('/', '')
  const validPattern = some(PATENT_REGEX_PATTERNS, (pattern: RegExp) =>
    value.match(pattern)
  )

  return validPattern
}
